/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tone_WarningInputs */

const cs_toast_tone_warning = /** @type {(inputs: Toast_Tone_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upozornění`)
};

const en_toast_tone_warning = /** @type {(inputs: Toast_Tone_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warning`)
};

/**
* | output |
* | --- |
* | "Warning" |
*
* @param {Toast_Tone_WarningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_tone_warning = /** @type {((inputs?: Toast_Tone_WarningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tone_WarningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_tone_warning(inputs)
	return cs_toast_tone_warning(inputs)
});